/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { NamedEnumerationValueDto } from './NamedEnumerationValueDto';
import {
    NamedEnumerationValueDtoFromJSON,
    NamedEnumerationValueDtoFromJSONTyped,
    NamedEnumerationValueDtoToJSON,
} from './NamedEnumerationValueDto';

/**
 * 
 * @export
 * @interface EnumerationDataSetSetupDto
 */
export interface EnumerationDataSetSetupDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetSetupDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetSetupDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetSetupDto
     */
    dataTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetSetupDto
     */
    iuid: string;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationDataSetSetupDto
     */
    origin: EntityOrigin;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationDataSetSetupDto
     */
    isIdenticalOverAllSetupValues: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationDataSetSetupDto
     */
    isIdenticalForSameDataType: boolean;
    /**
     * 
     * @type {Array<NamedEnumerationValueDto>}
     * @memberof EnumerationDataSetSetupDto
     */
    readonly values?: Array<NamedEnumerationValueDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetSetupDto
     */
    $type?: EnumerationDataSetSetupDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationDataSetSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoEnumerationDataSetSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationDataSetSetupDtoTypeEnum = typeof EnumerationDataSetSetupDtoTypeEnum[keyof typeof EnumerationDataSetSetupDtoTypeEnum];



/**
 * Check if a given object implements the EnumerationDataSetSetupDto interface.
 */
export function instanceOfEnumerationDataSetSetupDto(value?: unknown): value is EnumerationDataSetSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationDataSetSetupDtoTypeEnum)[0];
}

export function EnumerationDataSetSetupDtoFromJSON(json: any): EnumerationDataSetSetupDto {
    return EnumerationDataSetSetupDtoFromJSONTyped(json, false);
}

export function EnumerationDataSetSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationDataSetSetupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'dataTypeId': json['dataTypeId'],
        'iuid': json['iuid'],
        'origin': EntityOriginFromJSON(json['origin']),
        'isIdenticalOverAllSetupValues': json['isIdenticalOverAllSetupValues'],
        'isIdenticalForSameDataType': json['isIdenticalForSameDataType'],
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(NamedEnumerationValueDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationDataSetSetupDtoToJSON(value?: Omit<EnumerationDataSetSetupDto, 'values'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'dataTypeId': value['dataTypeId'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'isIdenticalOverAllSetupValues': value['isIdenticalOverAllSetupValues'],
        'isIdenticalForSameDataType': value['isIdenticalForSameDataType'],
        '$type': value['$type'],
    });
}

